import type { Locale } from "../../shared/dto";
import type { ClientSectionKey, StaffDetail, StaffRole, StaffRun } from "./model";

export type StaffPaneProps = {
  detail: StaffDetail;
  role: StaffRole;
  locale: Locale;
  t: (key: string) => string;
  run: StaffRun;
  refresh: () => Promise<void>;
  csrfToken?: string;
  /**
   * F138a: was `onOpenTab`. A pane no longer switches a tab, because there are
   * no tabs; it can ask the page to bring one of the three flat sections into
   * view (the blocked step sends an admin to Nastavení, parity row 7).
   */
  onOpenSection?: (section: ClientSectionKey) => void;
  /**
   * F138a (parity row 2): the "Výstupy" tab is gone, so a control that used to
   * open it opens the MATERIAL STEP the output belongs to - where the partner
   * reviews it, filtered to that one material.
   */
  onOpenStep?: (step: string) => void;
  currentUserId?: string;
};
export function parseValue(row: Record<string, unknown>): Record<string, unknown> {
  // Staff detail resource rows carry the value PRE-PARSED as `value` (the
  // server sets valueJson: undefined); fall back to parsing only if needed.
  if (row.value && typeof row.value === "object") return row.value as Record<string, unknown>;
  try { return JSON.parse(String(row.valueJson ?? row.value_json ?? "{}")) as Record<string, unknown>; } catch { return {}; }
}
